export default __webpack_public_path__ + "static/210511_KWM_by_Kruszewski_5MK_6398_background-6f267b6b0e2064ea6b0328a2a9a94bc1.mp4";